import { collection, query, where, onSnapshot, doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { useDispatch, useStore } from "react-redux";
import { updateDeviceMapAction } from "../actions/device.action";
import * as dev_constants from '../constants/dev_constants';
import {
  clearCounts, getErrorGrpId, isErrorGrpAlreadyExists, showDeviceAsOff, arraySymmetricDiff
} from "../utilities/dev_utils";
import { db, getCheckSession } from "./auth";
import { deviceErrorEventCode, deviceErrorEventCodeOrder } from "../constants/constants";
import { getDashboardMockData, isWithinSchedule } from "../query/dash-mock-query";
let dashboardDataInstance;

let dashboardDataMap = null;

let countsObject = {
  slcCnt: 0,
  slcOnCnt: 0,
  slcOffCnt: 0,
  slcErrCnt: 0,
  lmpCnt: 0,
  lmpOnCnt: 0,
  lmpOffCnt: 0,
  ilmCnt: 0,
  ilmOnCnt: 0,
  ilmOffCnt: 0,
  ilmErrCnt: 0,
  esp: 0,
  modes: {
    autoCnt: 0,
    manCnt: 0,
    bypCnt: 0
  },
  inpFaults: {
    lvCnt: 0,
    hvCnt: 0,
    pfCnt: 0,
    isofCnt: 0
  },
  outFaults: {
    tripCnt: 0,
    hcCnt: 0,
    cfCnt: 0
  },
  othFaults: {
    emfCnt: 0,
    doCnt: 0,
    lbCnt: 0,
    inaCnt: 0
  },
  errGrpCounts: Array(dev_constants.EventGrpMax).fill(0),
};


class DashboardData {
  constructor() {
    if (dashboardDataInstance) {
      throw new Error("Instance already created");
    }
    dashboardDataInstance = this;
  }
  /** Expoeted functions*/
  getInstance() {
    return dashboardDataInstance;
  }

  async initService() {
    dashboardDataMap = await getDashboardMockData().catch((e) => {
      console.log("Unable to receive dashboard data:", e);
    });

    // await this.writeData();
    return dashboardDataMap ?? null;
  }


  // async fetchDashboardData() {

  //     try {

  //         const docRef = doc(db(), "settings", "dashboard_data");
  //         const docSnap = await getDoc(docRef);

  //         if (docSnap.exists()) {
  //             var data = JSON.stringify(docSnap.data());
  //             console.log("Document data:", data);
  //             dashboardDataMap = docSnap.data();
  //             return docSnap.data();
  //         } else {
  //         // docSnap.data() will be undefined in this case
  //             console.log("No such document!");
  //         }

  //     } catch (err) {
  //         console.log(`Error - Get dashboard data : ${err}`);
  //     }
  //     return null;
  // }

  getUpdatedDashboardData(source, zone = 0, ward = 0) {
    var mockData = this.getDashboardData(zone, ward);
    if (mockData != null) {
      var cloneSource = JSON.parse(JSON.stringify(source));
      return { ...cloneSource, ...mockData };
    }
    return source;
  }


  getDashboardDataByKey(zone = 0, ward = 0, key = "") {
    var mockData = this.getDashboardData(zone, ward);
    if (mockData != null) {
      return mockData[key] ?? -1
    }
    return -1;
  }

  isGlobalScheduleActive() {
    if (dashboardDataMap != null && dashboardDataMap.on_time && dashboardDataMap.off_time) {
      return isWithinSchedule(dashboardDataMap.on_time, dashboardDataMap.off_time);
    }
    return false;
  }

  getDashboardData(zone = 0, ward = 0) {
    let result = null;
    if (dashboardDataMap != null) {
      if (dashboardDataMap.on_time && dashboardDataMap.off_time) {
        dashboardDataMap.isScheduled = isWithinSchedule(dashboardDataMap.on_time, dashboardDataMap.off_time);
      }
      try {
        dashboardDataMap.mockData?.forEach((element, index) => {
          // if (element?.status == 'active' && dashboardDataMap.isScheduled === true) {
          if (element?.status == 'active') {

            // var startTime = element?.schStart?.toDate();
            // var endTime = element?.schEnd?.toDate();
            // console.log(`Start : ${startTime}`)
            // console.log(`end : ${endTime}`)
            // console.log(`target : ${currentTime}`)
            // if (this.isTimeBetween(this.getTimeString(currentTime), this.getTimeString(startTime), this.getTimeString(endTime))) {
            if ((dashboardDataMap.isScheduled === true && element?.type == 1) || (dashboardDataMap.isScheduled === false && element?.type == 2)) {
              console.log("This is in time schedule");
              if (zone != 0) {
                // if (ward != 0) {
                /// Process ward data
                element?.filtered?.forEach((filterElement, filterIndex) => {
                  if (zone == filterElement.zone && ward == filterElement.ward) {
                    if (filterElement?.data != null && filterElement?.data != undefined) {
                      var mockData = filterElement.data;
                      result = { ...mockData, flag: true };
                      console.log(`===========Filter============== ${element.name}`);
                      return;
                    }
                  }
                });
                // } else {
                //     ///TODO:procell zone with all ward
                // }
              } else {
                if (element.default != null && element.default != undefined) {
                  var mockData = element.default;
                  result = { ...mockData, flag: true };
                  console.log(`===========Default============== ${element.name}`);
                  return;
                }
              }

            }
            // }
          } else {
            console.log("No active schedule matched");
          }
          console.log(element, index);
        });

        if (result != undefined && result != null && result.utdly != undefined) {
          // Get the current date and time
          const now = new Date();
          let startDate = new Date();

          // Check if the current time is less than 9 AM
          if (now.getHours() < 9) {
            startDate.setDate(now.getDate() - 1); // Start from the previous day
          }

          // Set start time to 9:00 AM
          startDate.setHours(9, 0, 0, 0);

          // Add "dt" field with Firestore Timestamp, decreasing by one day for each object
          result.utdly = result.utdly.map(item => {
            const itemWithDate = { ...item, dt: Timestamp.fromDate(new Date(startDate)) };
            startDate.setDate(startDate.getDate() - 1); // Decrease date by one day
            return itemWithDate;
          });
        }

        ///Update uptime hourly mock data
        if (result != undefined && result != null && result.uthrly != undefined) {
          // Get the current date and time
          const now = new Date();
          let startTime = new Date();

          // Check if the current time is less than the current hour
          if (now.getMinutes() === 0 && now.getSeconds() === 0 && now.getMilliseconds() === 0) {
            startTime.setHours(now.getHours() - 1); // Start from the previous hour
          }

          // Set the start time to the beginning of the last hour
          startTime.setMinutes(0, 0, 0);

          // Add "dt" field with Firestore Timestamp, decreasing by one hour for each object
          result.uthrly = result.uthrly.map(item => {
            const itemWithTime = { ...item, dt: Timestamp.fromDate(new Date(startTime)) };
            startTime.setHours(startTime.getHours() - 1); // Decrease time by one hour
            return itemWithTime;
          });

        }

        ///Update energy saving
        if (result != undefined && result != null && result.ensav != undefined) {
          // Get the current date and time
          const now = new Date();
          let startDate = new Date();

          // Check if the current time is less than 9 AM
          if (now.getHours() < 9) {
            startDate.setDate(now.getDate() - 1); // Start from the previous day
          }

          // Set start time to 9:00 AM
          startDate.setHours(9, 0, 0, 0);

          // Add "dt" field with Firestore Timestamp, decreasing by one day for each object
          result.ensav = result.ensav.map(item => {
            const itemWithDate = { ...item, dt: Timestamp.fromDate(new Date(startDate)) };
            startDate.setDate(startDate.getDate() - 1); // Decrease date by one day
            return itemWithDate;
          });
        }
      } catch (e) {
        console.log(`Error Dashboard data: ${e.toString()}`);
      }


    }
    return result;
  }

  isDashboardDataAvailable() {
    return dashboardDataMap == null ? false : true;
  }

  async writeData() {
    var result = await getDashboardMockData().catch((e) => {
      console.log("Unable to receive dashboard data");
    });
    // result = {
    //     "mockData": [
    //       {
    //         "filtered": [
    //           {
    //             "ward": 0,
    //             "zone": 2,
    //             "data": {
    //               "slcCnt": 288,
    //               "slcOnCnt": 284,
    //               "slcOffCnt": 4,
    //               "slcErrCnt": 0,
    //               "lmpCnt": 8075,
    //               "lmpOnCnt": 8025,
    //               "lmpOffCnt": 48,
    //               "lmpNcCnt": 0,
    //               "modes": {
    //                   "autoCnt": 798,
    //                   "manCnt": 6,
    //                   "bypCnt": 0
    //               },
    //               "inpFaults": {
    //                   "lvCnt": 1,
    //                   "hvCnt": 0,
    //                   "pfCnt": 3,
    //                   "isofCnt": 0
    //               },
    //               "outFaults": {
    //                   "tripCnt": 6,
    //                   "hcCnt": 0,
    //                   "cfCnt": 0
    //               },
    //               "othFaults": {
    //                   "emfCnt": 2,
    //                   "doCnt": 6,
    //                   "lbCnt": 5,
    //                   "inaCnt": 0
    //               }
    //             }
    //           },
    //           {
    //             "ward": 0,
    //             "zone": 3,
    //             "data": {
    //               "slcCnt": 250,
    //               "slcOnCnt": 248,
    //               "slcOffCnt": 2,
    //               "slcErrCnt": 0,
    //               "lmpCnt": 6139,
    //               "lmpOnCnt": 6086,
    //               "lmpOffCnt": 53,
    //               "lmpNcCnt": 0,
    //               "modes": {
    //                   "autoCnt": 798,
    //                   "manCnt": 6,
    //                   "bypCnt": 0
    //               },
    //               "inpFaults": {
    //                   "lvCnt": 1,
    //                   "hvCnt": 0,
    //                   "pfCnt": 3,
    //                   "isofCnt": 0
    //               },
    //               "outFaults": {
    //                   "tripCnt": 6,
    //                   "hcCnt": 0,
    //                   "cfCnt": 0
    //               },
    //               "othFaults": {
    //                   "emfCnt": 2,
    //                   "doCnt": 6,
    //                   "lbCnt": 5,
    //                   "inaCnt": 0
    //               }
    //             }
    //           },
    //           {
    //             "ward": 0,
    //             "zone": 4,
    //             "data": {
    //               "slcCnt": 270,
    //               "slcOnCnt": 267,
    //               "slcOffCnt": 3,
    //               "slcErrCnt": 0,
    //               "lmpCnt": 8199,
    //               "lmpOnCnt": 8138,
    //               "lmpOffCnt": 61,
    //               "lmpNcCnt": 0,
    //               "modes": {
    //                   "autoCnt": 798,
    //                   "manCnt": 6,
    //                   "bypCnt": 0
    //               },
    //               "inpFaults": {
    //                   "lvCnt": 1,
    //                   "hvCnt": 0,
    //                   "pfCnt": 3,
    //                   "isofCnt": 0
    //               },
    //               "outFaults": {
    //                   "tripCnt": 6,
    //                   "hcCnt": 0,
    //                   "cfCnt": 0
    //               },
    //               "othFaults": {
    //                   "emfCnt": 2,
    //                   "doCnt": 6,
    //                   "lbCnt": 5,
    //                   "inaCnt": 0
    //               }
    //             }
    //           }
    //         ],
    //         "default": {
    //           "ilmCnt": 808,
    //           "ilmOnCnt": 799,
    //           "ilmOffCnt": 9,
    //           "ilmErrCnt": 0,
    //           "slcCnt": 808,
    //           "slcOnCnt": 799,
    //           "slcOffCnt": 9,
    //           "slcErrCnt": 0,
    //           "lmpCnt": 22413,
    //           "lmpOnCnt": 19117,
    //           "lmpOffCnt": 186,
    //           "lmpNcCnt": 3035,
    //           "modes": {
    //               "autoCnt": 798,
    //               "manCnt": 6,
    //               "bypCnt": 0
    //           },
    //           "inpFaults": {
    //               "lvCnt": 1,
    //               "hvCnt": 0,
    //               "pfCnt": 3,
    //               "isofCnt": 0
    //           },
    //           "outFaults": {
    //               "tripCnt": 6,
    //               "hcCnt": 0,
    //               "cfCnt": 0
    //           },
    //           "othFaults": {
    //               "emfCnt": 2,
    //               "doCnt": 6,
    //               "lbCnt": 5,
    //               "inaCnt": 0
    //           }
    //         },
    //         "schStart": new Date("2024-01-01T18:35:00+05:30"),
    //         "schEnd": new Date("2024-01-01T09:00:00+05:30"),
    //         "status": "active",
    //         "name": "Evening Schedule"
    //       },
    //       {
    //         "filtered": [
    //           {
    //             "ward": 0,
    //             "zone": 2,
    //             "data": {
    //               "slcCnt": 288,
    //               "slcOnCnt": 0,
    //               "slcOffCnt": 288,
    //               "slcErrCnt": 0,
    //               "lmpCnt": 8075,
    //               "lmpOnCnt": 0,
    //               "lmpOffCnt": 8075,
    //               "lmpNcCnt": 0,
    //               "modes": {
    //                   "autoCnt": 798,
    //                   "manCnt": 6,
    //                   "bypCnt": 0
    //               },
    //               "inpFaults": {
    //                   "lvCnt": 1,
    //                   "hvCnt": 0,
    //                   "pfCnt": 3,
    //                   "isofCnt": 0
    //               },
    //               "outFaults": {
    //                   "tripCnt": 6,
    //                   "hcCnt": 0,
    //                   "cfCnt": 0
    //               },
    //               "othFaults": {
    //                   "emfCnt": 2,
    //                   "doCnt": 6,
    //                   "lbCnt": 5,
    //                   "inaCnt": 0
    //               }
    //             }
    //           },
    //           {
    //             "ward": 0,
    //             "zone": 3,
    //             "data": {
    //               "slcCnt": 250,
    //               "slcOnCnt": 0,
    //               "slcOffCnt": 250,
    //               "slcErrCnt": 0,
    //               "lmpCnt": 6139,
    //               "lmpOnCnt": 0,
    //               "lmpOffCnt": 6139,
    //               "lmpNcCnt": 0,
    //               "modes": {
    //                   "autoCnt": 798,
    //                   "manCnt": 6,
    //                   "bypCnt": 0
    //               },
    //               "inpFaults": {
    //                   "lvCnt": 1,
    //                   "hvCnt": 0,
    //                   "pfCnt": 3,
    //                   "isofCnt": 0
    //               },
    //               "outFaults": {
    //                   "tripCnt": 6,
    //                   "hcCnt": 0,
    //                   "cfCnt": 0
    //               },
    //               "othFaults": {
    //                   "emfCnt": 2,
    //                   "doCnt": 6,
    //                   "lbCnt": 5,
    //                   "inaCnt": 0
    //               }
    //             }
    //           },
    //           {
    //             "ward": 0,
    //             "zone": 4,
    //             "data": {
    //               "slcCnt": 270,
    //               "slcOnCnt": 0,
    //               "slcOffCnt": 270,
    //               "slcErrCnt": 0,
    //               "lmpCnt": 8199,
    //               "lmpOnCnt": 0,
    //               "lmpOffCnt": 8199,
    //               "lmpNcCnt": 0,
    //               "modes": {
    //                   "autoCnt": 798,
    //                   "manCnt": 6,
    //                   "bypCnt": 0
    //               },
    //               "inpFaults": {
    //                   "lvCnt": 1,
    //                   "hvCnt": 0,
    //                   "pfCnt": 3,
    //                   "isofCnt": 0
    //               },
    //               "outFaults": {
    //                   "tripCnt": 6,
    //                   "hcCnt": 0,
    //                   "cfCnt": 0
    //               },
    //               "othFaults": {
    //                   "emfCnt": 2,
    //                   "doCnt": 6,
    //                   "lbCnt": 5,
    //                   "inaCnt": 0
    //               }
    //             }
    //           }
    //         ],
    //         "default": {
    //           "ilmCnt": 808,
    //           "ilmOnCnt": 799,
    //           "ilmOffCnt": 9,
    //           "ilmErrCnt": 0,
    //           "slcCnt": 808,
    //           "slcOnCnt": 0,
    //           "slcOffCnt": 808,
    //           "slcErrCnt": 0,
    //           "lmpCnt": 22413,
    //           "lmpOnCnt": 0,
    //           "lmpOffCnt": 22413,
    //           "lmpNcCnt": 0,
    //           "modes": {
    //               "autoCnt": 798,
    //               "manCnt": 6,
    //               "bypCnt": 0
    //           },
    //           "inpFaults": {
    //               "lvCnt": 1,
    //               "hvCnt": 0,
    //               "pfCnt": 3,
    //               "isofCnt": 0
    //           },
    //           "outFaults": {
    //               "tripCnt": 6,
    //               "hcCnt": 0,
    //               "cfCnt": 0
    //           },
    //           "othFaults": {
    //               "emfCnt": 2,
    //               "doCnt": 6,
    //               "lbCnt": 5,
    //               "inaCnt": 0
    //           }
    //         },
    //         "schStart": new Date("2024-01-01T09:00:00+05:30"),
    //         "schEnd": new Date("2024-01-01T18:35:00+05:30"),
    //         "status": "active",
    //         "name": "Morning Schedule"
    //       }
    //     ]
    //   };
    if (result != null && result != undefined) {
      var data = {
        "utdly": [{
          "ncCnt": 60,
          "offCnt": 20,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 65,
          "offCnt": 15,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 70,
          "offCnt": 10,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 55,
          "offCnt": 25,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 80,
          "offCnt": 10,
          "onCnt": 10,
          "totCnt": 100
        },
        {
          "ncCnt": 75,
          "offCnt": 15,
          "onCnt": 10,
          "totCnt": 100
        },
        {
          "ncCnt": 68,
          "offCnt": 12,
          "onCnt": 20,
          "totCnt": 100
        }],
        "uthrly": [{
          "ncCnt": 60,
          "offCnt": 20,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 65,
          "offCnt": 15,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 70,
          "offCnt": 10,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 55,
          "offCnt": 25,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 80,
          "offCnt": 10,
          "onCnt": 10,
          "totCnt": 100
        },
        {
          "ncCnt": 75,
          "offCnt": 15,
          "onCnt": 10,
          "totCnt": 100
        },
        {
          "ncCnt": 68,
          "offCnt": 12,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 66,
          "offCnt": 14,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 72,
          "offCnt": 18,
          "onCnt": 10,
          "totCnt": 100
        },
        {
          "ncCnt": 76,
          "offCnt": 10,
          "onCnt": 14,
          "totCnt": 100
        },
        {
          "ncCnt": 85,
          "offCnt": 10,
          "onCnt": 5,
          "totCnt": 100
        },
        {
          "ncCnt": 90,
          "offCnt": 5,
          "onCnt": 5,
          "totCnt": 100
        },
        {
          "ncCnt": 95,
          "offCnt": 3,
          "onCnt": 2,
          "totCnt": 100
        },
        {
          "ncCnt": 58,
          "offCnt": 22,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 62,
          "offCnt": 18,
          "onCnt": 20,
          "totCnt": 100
        },
        {
          "ncCnt": 79,
          "offCnt": 15,
          "onCnt": 6,
          "totCnt": 100
        },
        {
          "ncCnt": 88,
          "offCnt": 6,
          "onCnt": 6,
          "totCnt": 100
        },
        {
          "ncCnt": 81,
          "offCnt": 12,
          "onCnt": 7,
          "totCnt": 100
        },
        {
          "ncCnt": 93,
          "offCnt": 4,
          "onCnt": 3,
          "totCnt": 100
        },
        {
          "ncCnt": 87,
          "offCnt": 10,
          "onCnt": 3,
          "totCnt": 100
        },
        {
          "ncCnt": 78,
          "offCnt": 15,
          "onCnt": 7,
          "totCnt": 100
        },
        {
          "ncCnt": 89,
          "offCnt": 7,
          "onCnt": 4,
          "totCnt": 100
        },
        {
          "ncCnt": 94,
          "offCnt": 4,
          "onCnt": 2,
          "totCnt": 100
        },
        {
          "ncCnt": 91,
          "offCnt": 5,
          "onCnt": 4,
          "totCnt": 100
        }],
        "ensav": [{ "esp": 40 },
        { "esp": 35 },
        { "esp": 45 },
        { "esp": 50 },
        { "esp": 30 },
        { "esp": 55 },
        { "esp": 60 },
        { "esp": 25 }]
      };
      result.mockData = result.mockData.map(item => {
        item.default = { ...item.default, ...data };
        return item;
      });
      await setDoc(doc(db(), "settings", "dashboard_data"), result);
    }

  }

  getTimeString(date) {
    if (date == undefined || date == null) {
      return `00:00:00`;
    }
    let hours = date.getHours().toString().padStart(2, '0');
    let minutes = date.getMinutes().toString().padStart(2, '0');
    let seconds = date.getSeconds().toString().padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  }

  // Function to compare only the time part of two Date objects
  compareTime(date1, date2) {
    let time1 = this.getTimeString(date1);
    let time2 = this.getTimeString(date2);

    if (time1 < time2) {
      // return 'date1 is earlier than date2';
      return -1;
    } else if (time1 > time2) {
      // return 'date1 is later than date2';
      return 1
    } else {
      // return 'date1 is the same time as date2';
      return 0;
    }
  }

  isTimeBetween(targetTime, startTime, endTime) {
    // Parse the time strings into Date objects
    const target = new Date(`1970-01-01T${targetTime}Z`);
    const start = new Date(`1970-01-01T${startTime}Z`);
    const end = new Date(`1970-01-01T${endTime}Z`);

    // Handle case where the time range crosses midnight
    if (start < end) {
      // Normal case: start time is before end time on the same day
      return target >= start && target <= end;
    } else {
      // Crossing midnight: end time is on the next day
      return target >= start || target <= end;
    }
  }
}

const DashboardDataService = Object.freeze(new DashboardData());
export default DashboardDataService;